import { useMonyawn } from "../context/MonyawnContext";
import { generateStory, createCandidateStoryRecord } from "../intelligence";
import { createCheckpoint } from "../workflow";

export function useCandidateStoryOps() {
  const {
    state,
    patchState,
    setNotice,
    selectedUser,
    selectedOpportunity,
    selectedProfile,
    opportunityProof,
    opportunityDMs,
  } = useMonyawn();

  const handleGenerateCandidateStory = async () => {
    if (!selectedOpportunity || !selectedUser || !selectedProfile) {
      setNotice({ tone: "info", message: "Missing profile data for the story." });
      return;
    }

    setNotice({ tone: "info", message: "Dropping your story..." });

    try {
      const storyDraft = await generateStory({
        user: selectedUser,
        opportunity: selectedOpportunity,
        profile: selectedProfile,
        artifacts: opportunityProof,
        correspondence: opportunityDMs,
        aiSettings: state.aiSettings,
      });

      const nextStory = createCandidateStoryRecord(storyDraft);
      const checkpoint = createCheckpoint(
        selectedOpportunity,
        "Story generated",
        "Story ready for review",
        "high",
        "proceed",
        "The story is now attached to this play.",
        "medium",
        "low",
      );

      patchState(
        (current) => ({
          ...current,
          candidateStories: [nextStory, ...current.candidateStories],
          checkpoints: [checkpoint, ...current.checkpoints],
        }),
        "Story generated and attached.",
      );

      return nextStory;
    } catch (error: any) {
      setNotice({ tone: "info", message: `Generation failed: ${error.message}` });
    }
  };

  return {
    handleGenerateCandidateStory,
  };
}
